import { createContext } from "react";

const GeofencePackageContext = createContext();

export default GeofencePackageContext;
